// src/components/CustomerSideBar.jsx
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaUser, FaHome, FaUtensils, FaShoppingCart, FaHeart,
  FaHistory, FaMapMarkerAlt, FaCreditCard,
  FaSignOutAlt, FaBars, FaTimes, FaBell, FaEnvelope
} from "react-icons/fa";
import logo from "../../../src/assets/logiscreen.png";
import LogoIcon from "../../assets/Logo";

const SideBarCustomer = ({ isOpen, onClose }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Customer-specific menu
  const customerMenuItems = [
    { label: "Home", icon: <FaHome />, path: "/customer" },
    { label: "Restaurants", icon: <FaUtensils />, path: "/customer/restaurants" },
    { label: "My Cart", icon: <FaShoppingCart />, path: "/customer/cart" },
    { label: "Favorites", icon: <FaHeart />, path: "/customer/favorites" },
    { label: "Orders", icon: <FaHistory />, path: "/customer/orders" },
    { label: "Addresses", icon: <FaMapMarkerAlt />, path: "/customer/addresses" },
    { label: "Payments", icon: <FaCreditCard />, path: "/customer/payments" },
  ];

  return (
    <>
      {/* ✅ Mobile Top Navbar */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-40 bg-white shadow flex items-center justify-between px-4 py-2">
        <img src={logo} alt="Logo" className="h-8" />
        <div className="flex items-center gap-4 text-gray-700 text-lg">
          <FaEnvelope className="cursor-pointer hover:text-rose-600" />
          <FaBell className="cursor-pointer hover:text-rose-600" />
          <button onClick={() => setMobileMenuOpen(true)}>
            <FaBars />
          </button>
        </div>
      </div>

      {/* ✅ Sidebar (desktop or mobile slide-in) */}
      <div
        className={`fixed top-0 left-0 md:h-full h-[95%] overflow-scroll w-72 bg-white shadow-lg z-50 transition-transform ${
          isOpen || mobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        } md:relative md:translate-x-0`}
      >
        {/* Mobile Close Button */}
        <div className="md:hidden flex justify-end p-2">
          <button onClick={() => setMobileMenuOpen(false)} className="text-gray-700">
            <FaTimes size={20} />
          </button>
        </div>

        {/* Sidebar Content */}
        <div className="p-4 border-b">
          <LogoIcon />
          <h1 className="text-lg font-bold mt-3">Foodie</h1>
          <p className="text-sm text-gray-500">Good food within minutes</p>
        </div>

        <div className="p-4 space-y-2">
          {/* User Profile Section */}
          <div className="flex items-center gap-2 p-2 bg-gray-50 rounded">
            <FaUser className="text-gray-600" />
            <div>
              <p className="text-sm font-bold">John Doe</p>
              <p className="text-xs text-gray-500">Customer</p>
            </div>
          </div>

          {/* Customer Navigation */}
          <div className="mt-6">
            <p className="font-semibold text-sm mb-2">Customer Menu</p>
            {customerMenuItems.map((item, i) => (
              <Link
                key={i}
                to={item.path}
                className={`flex items-center gap-2 text-sm p-2 rounded mb-1 ${
                  location.pathname === item.path
                    ? "bg-rose-600 text-white"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                {item.icon} {item.label}
              </Link>
            ))}
          </div>

          {/* Quick Actions */}
          <div className="mt-6">
            <p className="font-semibold text-sm mb-2">Quick Actions</p>
            <div className="grid grid-cols-2 gap-2">
              <Link to="/customer/trackorder" className="bg-blue-100 text-blue-700 text-xs p-2 rounded text-center">
                Track Order
              </Link>
              <button className="bg-green-100 text-green-700 text-xs p-2 rounded text-center">
                Offers
              </button>
            </div>
          </div>

          {/* Current Order Status */}
          <div className="mt-6 p-3 bg-gray-50 rounded">
            <p className="font-semibold text-sm mb-2">Current Order</p>
            <div className="space-y-2 text-xs">
              <div className="flex justify-between">
                <span>Restaurant:</span>
                <span className="font-bold">Burger King</span>
              </div>
              <div className="flex justify-between">
                <span>ETA:</span>
                <span className="font-bold">15 min</span>
              </div>
              <div className="flex justify-between">
                <span>Items:</span>
                <span className="font-bold">3</span>
              </div>
            </div>
          </div>

          {/* Settings & Logout */}
          <div className="mt-6">
            <button className="flex items-center gap-2 text-sm p-2 rounded text-red-600 hover:bg-red-50 w-full text-left">
              <FaSignOutAlt /> Logout
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBarCustomer;
